import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { services } from "../Data";
import About from "../Components/About";
import WhatIsService from "../Components/WhatIsService";
import ServicePoints from "../Components/ServicePoints";
import OurNetwork from "../Components/OurNetwork";
import ServiceManage from "../Components/ServiceManage";
import IndustriesSlider from "../Components/IndustriesSlider";
import WhyChoose from "../Components/WhyChoose";
import ServiceCta from "../Components/ServiceCta";

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = services.find(item => item.slug === slug);

  useEffect(() => {
    if (!service) return;
    document.title = service.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", service.metaDesc);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://shivamtransworld.in/services/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      service.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      service.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://shivamtransworld.in/services/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      service.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      service.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

}, [service, slug]);

  if (!service) return <h2>Service not found</h2>;
  

  return (
    <>
     <React.Fragment key={slug}>
        <div className="spacing-div"></div>

        <About
          subheading={service.subheading}
          heading={service.pageheading}
          headingTag="h1"
          subtext={service.subText}
          buttonText="Get a Quote"
          image={service.image}
          buttonLink="/enquiry#enquiry-form"
        />

        <WhatIsService
          title={service.infoTitle}
          description={service.infoDesc}
        />

        <ServicePoints
          title={service.pointsSecHeading}
          desc={service.pointsSecDesc}
          points={service.pointsSecData}
        />

        <OurNetwork />

        <ServiceManage
          label="How we Work"
          title={service.serviceManageTitle}
          description={service.serviceManageDesc}
          steps={service.serviceManagePoints}
          bgImage={service.servicemanageBg}
        />

        <IndustriesSlider />

        <WhyChoose
          heading={service.whychooseTitle}
          imageSrc={service.whychooseImg}
          paragraph={service.whychooseDesc}
          listItems={service.whychoosePoints}
        />

        <ServiceCta
          title={service.ctaTitle}
          text={service.ctaText}
          cta={service.cta}
          bgImage={service.ctaImage}
        />
     </React.Fragment>
   </>
  );
};

export default ServiceDetail;
